import { useEffect, useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";
import { track } from "@/lib/api";

const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

export function VoiceButton({ onResult, className = "" }) {
  const [listening, setListening] = useState(false);
  const rec = useRef(null);

  useEffect(() => () => rec.current?.abort?.(), []);
  if (!SR) return null;

  const start = () => {
    if (listening) { rec.current?.stop(); return; }
    const r = new SR();
    r.lang = "pt-BR"; r.interimResults = true; r.maxAlternatives = 1;
    r.onstart = () => setListening(true);
    r.onend = () => setListening(false);
    r.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed") toast.error("Permita o uso do microfone para buscar por voz.");
      else if (e.error !== "aborted") toast.error("Não entendi. Tente falar de novo.");
    };
    r.onresult = (e) => {
      const t = Array.from(e.results).map((x) => x[0].transcript).join("");
      onResult(t, e.results[e.results.length - 1].isFinal);
      if (e.results[e.results.length - 1].isFinal) track("voice_search", t.toLowerCase());
    };
    rec.current = r;
    r.start();
  };

  return (
    <button type="button" onClick={start} data-testid="voice-search-btn" title="Buscar por voz"
      aria-label={listening ? "Parar gravação" : "Buscar por voz"}
      className={`p-2 rounded-xl transition-colors ${listening ? "bg-red-500/20 text-red-300 animate-pulse" : "hover:bg-white/10 text-gray-400 hover:text-cyan-300"} ${className}`}>
      {listening ? <MicOff className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
    </button>
  );
}
